import { FC, ReactElement } from 'react';
import { SelectValue } from 'antd/es/select/index';
import { useSelector, useDispatch } from 'dva';
import { Select } from 'iglooform';

const SwitchLang: FC<any> = (props): ReactElement => {
  const { languages, currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );
  const dispatch = useDispatch();

  const handleChange = (currentLang: SelectValue) => {
    dispatch({
      type: 'global/setData',
      payload: {
        currentLang,
      },
    });
  };
  return (
    <Select
      value={currentLang as string}
      size="small"
      onChange={handleChange}
      {...props}
    >
      {languages.map(({ title, key }) => (
        <Select.Option key={key} value={key}>
          {title}
        </Select.Option>
      ))}
    </Select>
  );
};

export { SwitchLang };
